import React from "react";
import {
  StyledBrandLogo,
  StyledLogoutButton,
  StyledNav,
  StyledNavItem,
  StyledNavLink,
  StyledTopAppBar,
  StyledTopAppBarWrapper,
  StyledPageTitle,
  StyledButton,
  StyledButtonList,
  StyledButtonItem,
} from "./styled";
import SearchBar from "../SearchBar";
import logout from "../../assets/icons/logout.svg";
import { useAuthStore } from "../../stores/authStore";
import { LinearProgress, ListSubheader, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import GroupIcon from "@mui/icons-material/Group";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";
import { Link } from "react-router-dom";

const TopAppBar = ({ manageLabel = "Videos", ...props }: any) => {
  const setIsShowLogoutModal = useAuthStore(
    (state: any) => state.setIsShowLogoutModal,
  );
  const isLoading = useContentStore((state: any) => state.isLoading);
  const showLoading = props.isLoading ?? isLoading;
  const rolePermissions = useRolePermissionsStore(
    (state: any) => state.rolePermissions,
  );
  const [manageAnchorPosition, setManageAnchorPosition] =
    React.useState<null | {
      top: number;
      left: number;
    }>(null);
  const topAppBarRef = React.useRef<HTMLDivElement>(null);

  const onLogout = async () => {
    setIsShowLogoutModal(true);
  };

  const handleManageClick = (event: React.MouseEvent<HTMLElement>) => {
    const headerRect = topAppBarRef.current?.getBoundingClientRect();
    const triggerRect = event.currentTarget.getBoundingClientRect();

    setManageAnchorPosition({
      top: headerRect?.bottom ?? triggerRect.bottom,
      left: triggerRect.right,
    });
  };

  const handleManageClose = () => {
    setManageAnchorPosition(null);
  };

  const hasUserManagementCapability = rolePermissions?.userManagement === true;
  const hasVideoManageCapability = rolePermissions?.video?.manage === true;

  return (
    <StyledTopAppBar ref={topAppBarRef}>
      <StyledTopAppBarWrapper>
        {props.pageTitle && !props.isShowDetails && !props.isEditDetails ? (
          <StyledPageTitle>{props.pageTitle}</StyledPageTitle>
        ) : props.isShowDetails ? (
          <>
            <StyledPageTitle>{props.pageTitle}</StyledPageTitle>
            <StyledButton
              onClick={props.onClose}
              style={{
                color: "#000",
                fontFamily: "Inter",
                fontSize: "1.25rem",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "normal",
                textTransform: "uppercase",
              }}
              disabled={props.isCancelDisabled}
            >
              {props.btnClose}
            </StyledButton>
          </>
        ) : props.isEditDetails ? (
          <>
            <StyledPageTitle>{props.pageTitle}</StyledPageTitle>
            <StyledButtonList>
              <StyledButtonItem>
                <StyledButton
                  onClick={props.onCancel}
                  background={"rgba(255, 255, 255, 0.20)"}
                  backgroundHovered={"rgba(255, 255, 255, 0.1)"}
                  style={{
                    color: "#fff",
                    fontFamily: "Inter",
                    fontSize: "1.25rem",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                    textTransform: "uppercase",
                  }}
                  disabled={props.isCancelDisabled}
                >
                  {props.btnCancel}
                </StyledButton>
              </StyledButtonItem>
              <StyledButtonItem>
                <StyledButton
                  onClick={props.onSave}
                  style={{
                    color: "#000",
                    fontFamily: "Inter",
                    fontSize: "1.25rem",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal",
                    textTransform: "uppercase",
                  }}
                >
                  {props.btnSave}
                </StyledButton>
              </StyledButtonItem>
            </StyledButtonList>
          </>
        ) : (
          <>
            <StyledBrandLogo />
            {props.nav === "main" ? (
              <SearchBar />
            ) : (
              <div style={{ width: "35%" }}></div>
            )}
            {(hasUserManagementCapability || hasVideoManageCapability) && (
              <StyledNav>
              <StyledNavItem>
                <StyledNavLink
                  as={Link}
                  isactive={(props.nav === "main").toString()}
                  to="/main"
                >
                  {locale.nav_browse}
                </StyledNavLink>
              </StyledNavItem>
              <StyledNavItem>
                {hasVideoManageCapability &&
                  (hasUserManagementCapability ? (
                    <StyledNavLink
                      as="button"
                      type="button"
                      isactive={(props.nav === "manage").toString()}
                      onClick={handleManageClick}
                      aria-haspopup="menu"
                      aria-expanded={Boolean(manageAnchorPosition)}
                    >
                      {`${locale.nav_manage}: ${manageLabel}`}
                      <ArrowDropDownIcon fontSize="small" />
                    </StyledNavLink>
                  ) : (
                    <StyledNavLink
                      as={Link}
                      isactive={(props.nav === "manage").toString()}
                      to="/manage"
                    >
                      {`${locale.nav_manage}: ${manageLabel}`}
                    </StyledNavLink>
                  ))}
                <Menu
                  anchorReference="anchorPosition"
                  anchorPosition={manageAnchorPosition ?? undefined}
                  open={Boolean(manageAnchorPosition)}
                  onClose={handleManageClose}
                  MenuListProps={{
                    sx: {
                      p: 0,
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      fontFamily: "Inter",
                      fontSize: "1rem",
                    },
                  }}
                  PaperProps={{
                    sx: {
                      boxSizing: "border-box",
                      width: "250px",
                      minHeight: "115px",
                      borderRadius: "4px",
                      padding: "12px",
                      boxShadow: "0px 2px 4px 0px #00000080",
                    },
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <ListSubheader
                    component="div"
                    disableSticky
                    sx={{
                      height: "19px",
                      lineHeight: "19px",
                      p: 0,
                      color: "inherit",
                      fontFamily: "Inter",
                      fontSize: "1rem",
                      fontWeight: 600,
                    }}
                  >
                    {locale.nav_manage}
                  </ListSubheader>
                  <MenuItem
                    component={Link}
                    to="/manage"
                    onClick={handleManageClose}
                    sx={{
                      height: "24px",
                      minHeight: "24px",
                      p: 0,
                      gap: "8px",
                      fontFamily: "Inter",
                      fontSize: "1rem",
                      fontWeight: 400,
                      "&:hover": { backgroundColor: "#e6e6e6" },
                    }}
                  >
                    <VideoLibraryIcon fontSize="small" />
                    Videos
                  </MenuItem>
                  {hasUserManagementCapability && (
                    <MenuItem
                      component={Link}
                      to="/manage/users"
                      onClick={handleManageClose}
                      sx={{
                        height: "24px",
                        minHeight: "24px",
                        p: 0,
                        gap: "8px",
                        fontFamily: "Inter",
                        fontSize: "1rem",
                        fontWeight: 400,
                        "&:hover": { backgroundColor: "#e6e6e6" },
                      }}
                    >
                      <GroupIcon fontSize="small" />
                      Users
                    </MenuItem>
                  )}
                </Menu>
              </StyledNavItem>
              </StyledNav>
            )}
            <StyledLogoutButton onClick={() => onLogout()}>
              <img src={logout} alt="logout-icon" />
            </StyledLogoutButton>
          </>
        )}
      </StyledTopAppBarWrapper>
      {showLoading && <LinearProgress color="primary" />}
    </StyledTopAppBar>
  );
};

export default TopAppBar;
